var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWerkSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.66568C10 10.1757 9.58667 10.589 9.07667 10.589C8.56733 10.589 8.15333 10.1757 8.15333 9.66568V7.51235C8.15333 7.00235 8.56733 6.58901 9.07667 6.58901C9.58667 6.58901 10 7.00235 10 7.51235V9.66568ZM6.92333 9.66568C6.92333 10.1757 6.51 10.589 6 10.589C5.49 10.589 5.07667 10.1757 5.07667 9.66568V7.51235C5.07667 7.00235 5.49 6.58901 6 6.58901C6.51 6.58901 6.92333 7.00235 6.92333 7.51235V9.66568ZM3.84667 9.66568C3.84667 10.1757 3.43267 10.589 2.92333 10.589C2.41333 10.589 2 10.1757 2 9.66568V7.51235C2 7.00235 2.41333 6.58901 2.92333 6.58901C3.43267 6.58901 3.84667 7.00235 3.84667 7.51235V9.66568ZM6 3.25568V1.16768C6 0.635678 5.406 0.317678 4.96333 0.613012L0.594 2.85968C0.222667 3.10701 0 3.52368 0 3.96901V11.2557C0 11.9917 0.597333 12.589 1.33333 12.589H10.6667C11.4027 12.589 12 11.9917 12 11.2557V1.16768C12 0.635678 11.406 0.317678 10.9633 0.613012L6 3.25568Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWerkSvg);
export default __webpack_public_path__ + "static/media/WerkSvg.6bb68a409204534a1e05c09e9fa47d24.svg";
export { ForwardRef as ReactComponent };